export class Marquee {
	readonly $container: HTMLElement;
	protected $content: HTMLElement;
	protected $closeButton: HTMLButtonElement;

	constructor(selector: HTMLElement) {
		this.$container = selector;
		if (!this.$container) return;

		this.init();
	}

	public init(): void {
		const content = this.$container.querySelector<HTMLElement>('.marquee__content');
		const closeButton = this.$container.querySelector<HTMLButtonElement>('.marquee__close-button');
		if (!content) return;

		this.$content = content;
		this.$closeButton = closeButton;

		this.enableAnimation();
		this.injectSeparators();
		this.cloneContent();

		this.$closeButton && this.$closeButton.addEventListener('click', this.close);
	}

	private enableAnimation(): void {
		this.$content.classList.add('marquee--animation');
	}

	private injectSeparators(): void {
		const separatorText = this.$container.dataset.separator;

		if (!separatorText) return;

		const items = this.$content.querySelectorAll<HTMLElement>('.marquee__item');

		items.forEach((item) => {
			const separator = document.createElement('li');
			separator.classList.add('marquee__separator');
			separator.textContent = separatorText;

			item.after(separator);
		});
	}

	private cloneContent(): void {
		const copy = this.$content.cloneNode(true) as HTMLElement;
		this.$container.append(copy);
	}

	private close = (): void => {
		this.$container.dispatchEvent(new CustomEvent('marquee:close'));
		this.$container.classList.add('marquee--closed');
	};
}
